// Personal portraits of Patrice.
// When she sends real photos, just paste their URL into `src`. Leave others null
// for the editorial "Foto folgt" placeholder to keep rendering automatically.

const ASSET = (path) =>
  `https://customer-assets.emergentagent.com/job_peony-redesign/artifacts/${path}`;

export const PORTRAITS = {
  // Used on the homepage about-teaser column (3:4 portrait). "Das bin ich" — Patrice mit Hut.
  homeTeaser: {
    src: ASSET("9czn0l0d_IMG_3207.jpg"),
    alt: "Patrice Schreiter — Portrait mit Hut",
    caption: null,
    aspect: "3/4",
    tone: "warm",
    label: null,
  },
  // Used on the About hero (3:4 portrait, soft natural-light feel).
  aboutHero: {
    src: ASSET("9czn0l0d_IMG_3207.jpg"),
    alt: "Patrice — Portrait",
    caption: null,
    aspect: "3/4",
    tone: "depth",
    label: null,
  },
  // Two storytelling photos inside the About chapters.
  aboutCorporate: {
    src: null,
    alt: "Patrice – das vorherige Leben",
    caption: "Before",
    aspect: "4/5",
    tone: "depth",
    label: "Foto · vorher",
  },
  aboutToday: {
    src: null,
    alt: "Patrice arbeitet digital",
    caption: "Heute · digital",
    aspect: "4/5",
    tone: "warm",
    label: "Foto · heute",
  },
  // Sabbatical photo strip — three real polaroids from the journey. Landscape (4:3) to keep originals from being squashed.
  sabbaticalBali: {
    src: ASSET("nzmsjl6u_IMG_1285.jpg"),
    alt: "Bali — Tempeltor",
    caption: "Bali",
    aspect: "4/3",
    tone: "warm",
  },
  sabbaticalAotearoa: {
    src: ASSET("cglqy1xf_DSC00501.jpg"),
    alt: "Aotearoa — auf dem Gipfel",
    caption: "Aotearoa",
    aspect: "4/3",
    tone: "depth",
  },
  sabbaticalRarotonga: {
    src: ASSET("i9ukqsd2_LRG_DSC01962%20%282%29.JPG"),
    alt: "Rarotonga — am Meer",
    caption: "Rarotonga",
    aspect: "4/3",
    tone: "warm",
  },
  // Contact page – small portrait next to signature.
  contactSide: {
    src: ASSET("9czn0l0d_IMG_3207.jpg"),
    alt: "Patrice — am Schreibtisch",
    caption: null,
    aspect: "4/5",
    tone: "warm",
    label: null,
  },
};
